import { IEnquiry, IEnquiryStatus } from '@wot/typings';
import xhr from '../utils/fetch';

const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: IEnquiry[] }> => {
  return await xhr({
    url: `/a/enquiries`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getById = async (id: string) => {
  return await xhr({
    url: `/a/enquiries/${id}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const updateStatus = async (id: string, body: { action: IEnquiryStatus }) => {
  return await xhr({
    url: `/a/enquiries/${id}/status`,
    method: 'PUT',
    body: body
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const enquiryApi = {
  get,
  getById,
  updateStatus
};

export default enquiryApi;
